import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    background-color: ${vars.colorDark};

    .courses-serach-form {
        display: flex;
        gap: 1em;
        padding: 0 1em;

        .input-search {
            min-width: 70%;
        }
    }

    .courses-results {
        min-height: 60em;

        .courses-results-empty {
            color: ${vars.colorTextWhite};
            display: flex;
            flex-flow: column wrap;
            justify-content: center;
            align-items: center;
            gap: 1em;
            height: 100%;
            margin: 10em 0 0 0;

            .empty-title {
                font-size: 1.8em;
                font-weight: 600;
            }

            .empty-description {
                font-size: 1.1em;

                .empty-description-click {
                    font-weight: 600;
                    color: ${vars.colorViolet};
                    cursor: pointer;

                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletS}) {
        .courses-serach-form {
            flex-flow: column wrap;
            margin: 0 auto;
            max-width: 90%;
        }

        .courses-results {
            .courses-results-empty {
                max-width: 90%;
                margin: 5em auto;
                text-align: center;
            }
        }
    }
`;
